module.exports = __webpack_public_path__ + "img/chat.5296d7bd.svg";